<div class="offer-activity-feed" *ngIf="!isError && !isLoading">
  <h5 class="activity-feed-title">Activity Feed</h5>

  <!-- Loading state -->
  <div *ngIf="isLoading" class="activity-feed-loading">
    <p-skeleton width="100%" height="2rem" styleClass="mb-2"></p-skeleton>
    <p-skeleton width="100%" height="2rem" styleClass="mb-2"></p-skeleton>
    <p-skeleton width="100%" height="2rem" styleClass="mb-2"></p-skeleton>
  </div>

  <!-- Data table — paginator only appears when there are more than 10 records -->
  <p-table
    *ngIf="!isLoading && !isError"
    [value]="records"
    [rows]="10"
    [paginator]="records.length > 10"
    [rowsPerPageOptions]="[10, 25, 50]"
    currentPageReportTemplate="{first}-{last} of {totalRecords}"
    [showCurrentPageReport]="true"
    styleClass="p-datatable-sm"
  >
    <ng-template pTemplate="header">
      <tr>
        <th>Customer Name</th>
        <th pSortableColumn="returnStatus">
          Used Offer
          <p-sortIcon field="returnStatus"></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-record>
      <tr>
        <td>{{ record.customerName }}</td>
        <td>
          <p-tag
            [severity]="getStatusSeverity(record.returnStatus)"
            [value]="getStatusLabel(record.returnStatus)"
            [icon]="getStatusIcon(record.returnStatus)"
          ></p-tag>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="2" class="text-center">No activity records found.</td>
      </tr>
    </ng-template>
  </p-table>
</div>
